module.exports = __webpack_public_path__ + "img/e.728c92d6.jpg";